import React from 'react';
import CaseStudiesGrid from '../components/sections/CaseStudiesGrid';
import Banner4 from '../components/sections/Banner4';

const CaseStudies = () => {
  return (
    <main className="bg-black min-h-screen">
      <div className="pt-12 md:pt-32">
        <CaseStudiesGrid />
      </div>
      <Banner4 />
    </main>
  );
};

export default CaseStudies;
